import React from 'react';

const SidebarMode = () => {
    return (
        <>
        <div className='px-3'>
        <div className='flex w-full overflow-hidden rounded-full bg-zinc-100 p-2 text-sm dark:bg-zinc-950'>
            <button type="button"className="p-1.5 rounded-full text-zinc-500 dark:hover:text-zinc-100 flex flex-auto items-center justify-center truncate hover:text-zinc-950 transition-all duration-300 ease-in-out gap-1">
                <i class="fa-regular fa-moon"></i>
                <span class="overflow-hidden truncate whitespace-nowrap">Dark</span>
            </button>

            <button type="button"className="p-1.5 rounded-full text-zinc-500 dark:hover:text-zinc-100 flex flex-auto items-center justify-center truncate bg-white shadow-lg dark:bg-zinc-800 dark:text-white transition-all duration-300 ease-in-out gap-1">
                <i class="fa-regular fa-sun"></i>
                <span class="overflow-hidden truncate whitespace-nowrap">Light</span>
            </button>

            <button type="button"className="p-1.5 rounded-full text-zinc-500 dark:hover:text-zinc-100 flex flex-auto items-center justify-center truncate hover:text-zinc-950 transition-all duration-300 ease-in-out gap-1">
                <i class="fa-regular fa-computer"></i>
                <span class="overflow-hidden truncate whitespace-nowrap">System</span>
            </button>

        </div>
        </div>
        </>
    );
};

export default SidebarMode;